module.exports = __webpack_public_path__ + "static/img/b2c82b49ae3d3e57dc51a49863468ba7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/process_row_active.png
// module id = kIe9
// module chunks = 1